"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = void 0 && (void 0).__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var mobx_react_1 = require("mobx-react");

var RuleConstants_1 = require("../../definitions/constants/RuleConstants");

var IconPickerComponent_1 = __importDefault(require("../iconPicker/IconPickerComponent"));

var ColorPickerComponent_1 = __importDefault(require("../colorPicker/ColorPickerComponent"));

var UnexpandedRuleComponent_1 = __importDefault(require("./UnexpandedRuleComponent"));

var ConditionComponent_1 = __importDefault(require("./ConditionComponent"));

var StringResources_1 = __importDefault(require("../../nls/StringResources"));

var IconsMap_1 = __importDefault(require("../../definitions/constants/IconsMap"));

var ColorUtil_1 = __importDefault(require("../../utils/ColorUtil"));

var KeyCodes_1 = require("../../utils/KeyCodes");

var ca_ui_toolkit_1 = require("ca-ui-toolkit");

require("./RuleCSS.scss");

var RANGE_CONDITION_TYPES = ['GT', 'GTE', 'LT', 'LTE'];

var RuleComponent =
/** @class */
function (_super) {
  __extends(RuleComponent, _super);

  function RuleComponent(props, state) {
    var _this = _super.call(this, props, state) || this;

    _this.nodeRef = react_1.default.createRef();
    return _this;
  }

  RuleComponent.prototype.componentDidUpdate = function () {
    return this._updateComponent();
  };

  RuleComponent.prototype.componentDidMount = function () {
    return this._updateComponent();
  };

  RuleComponent.prototype.render = function () {
    var _a = this.props,
        removeRule = _a.removeRule,
        onRowMove = _a.onRowMove,
        ruleIndex = _a.ruleIndex,
        ruleModel = _a.ruleModel,
        uiContext = _a.uiContext,
        scale = _a.scale,
        colorPickerModel = _a.colorPickerModel;
    var iconOptions = IconsMap_1.default.getIconDefinitions(uiContext.getIcons());
    var hasValidEndCondition = ruleModel.hasOperator && ruleModel.hasEndCondition;
    var endConditionType = hasValidEndCondition ? ruleModel.getEndCondition().conditionType : '';
    var endConditionValue = hasValidEndCondition ? ruleModel.endConditionValue : null;
    var initialExpanded = false; // Always render as collapse , then expand it during component did mount

    var disableAndCheckBox = !this._supportRangeCondition(ruleModel.getStartCondition().conditionType);
    var fillLabel = ruleModel.getFillHexColor() || StringResources_1.default.get('conditionalFormattingNoColor');
    return react_1.default.createElement(ca_ui_toolkit_1.ExpandableTile, {
      initialExpanded: initialExpanded,
      className: ca_ui_toolkit_1.classnames('vis-cf-rules-listItem', "vis-cf-rules-listitem-" + ruleIndex, {
        expanded: initialExpanded
      }),
      label: ruleModel.getExpand() ? null : react_1.default.createElement(UnexpandedRuleComponent_1.default, {
        label: ruleModel.label,
        fontColor: ruleModel.getTextHexColor(),
        backgroundColor: ColorUtil_1.default.getRgbaColorFromHexColor(ruleModel.getFillHexColor(), this.props.backgroundOpacity),
        pattern: ruleModel.getFillPattern(),
        onRowMove: onRowMove,
        ruleIndex: ruleIndex,
        selectedIcon: ruleModel.hasShape ? IconsMap_1.default.getShapeDefinition(uiContext.getIcons(), ruleModel.getShape()) : '',
        icons: uiContext.getIcons()
      }),
      maxWidth: '100%',
      onChange: function onChange(isExpanded) {
        ruleModel.setExpand('RuleComponent', ruleIndex, isExpanded);
      },
      ref: this.nodeRef
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      direction: 'column',
      className: ca_ui_toolkit_1.classnames('vis-cf-expand-content')
    }, react_1.default.createElement(ca_ui_toolkit_1.FlexItem, null, react_1.default.createElement(ca_ui_toolkit_1.Label, {
      label: StringResources_1.default.get('conditionalFormattingIfValueIs'),
      style: {
        fontWeight: 'bold',
        fontSize: '14px'
      }
    })), react_1.default.createElement(ConditionComponent_1.default, {
      classPrefix: 'start',
      type: ruleModel.getStartCondition().conditionType,
      value: ruleModel.startConditionValue,
      onTypeChange: function onTypeChange(selectedType) {
        ruleModel.setStartType(ruleIndex, selectedType); // if non paired option selected, clear end condition.

        var dropDownValues = ruleModel.dropDownValues;

        if (!dropDownValues.includes(selectedType)) {
          ruleModel.setOperator(ruleIndex, RuleConstants_1.RangeOperators.none);
        }
      },
      valueOnChange: function valueOnChange(newValue) {
        ruleModel.setStartValue(ruleIndex, newValue);
      },
      scale: scale,
      options: ruleModel.getStartConditionOptions(),
      uiContext: uiContext
    }), react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      className: ca_ui_toolkit_1.classnames('vis-cf-checkbox-container')
    }, react_1.default.createElement(ca_ui_toolkit_1.Checkbox, {
      className: ca_ui_toolkit_1.classnames(!ruleModel.hasOperator ? 'vis-cf-checkbox-not-checked' : 'vis-cf-checkbox-checked'),
      name: "operator-" + ruleIndex,
      label: StringResources_1.default.get('conditionalFormattingAND'),
      align: 'left',
      disabled: disableAndCheckBox,
      checked: ruleModel.hasOperator,
      onChange: function onChange(currentStatus) {
        if (currentStatus) {
          ruleModel.setOperator(ruleIndex, RuleConstants_1.RangeOperators.and);
        } else {
          ruleModel.setOperator(ruleIndex, RuleConstants_1.RangeOperators.none);
        }
      }
    })), ruleModel.hasOperator ? react_1.default.createElement(ConditionComponent_1.default, {
      classPrefix: 'end',
      type: endConditionType,
      value: endConditionValue,
      onTypeChange: function onTypeChange(selectedType) {
        ruleModel.setEndType(ruleIndex, selectedType);
      },
      valueOnChange: function valueOnChange(newValue) {
        ruleModel.setEndValue(ruleIndex, newValue);
      },
      scale: scale,
      options: ruleModel.getEndConditionOptions(),
      uiContext: uiContext
    }) : null, react_1.default.createElement(ca_ui_toolkit_1.FlexItem, null, react_1.default.createElement(ca_ui_toolkit_1.Label, {
      label: StringResources_1.default.get('conditionalFormattingRuleStyle'),
      style: {
        fontWeight: 'bold',
        fontSize: '14px',
        marginTop: '24px',
        marginBottom: '16px'
      }
    })), react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      direction: 'row',
      className: ca_ui_toolkit_1.classnames('vis-cf-style-item-container'),
      maxWidth: 'unset'
    }, react_1.default.createElement(ca_ui_toolkit_1.Label, {
      label: StringResources_1.default.get('conditionalFormattingTextColor'),
      style: {
        fontSize: '14px'
      }
    }), react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      direction: 'row',
      className: ca_ui_toolkit_1.classnames('vis-cf-rule-picker-container', 'rule-color-picker-container')
    }, react_1.default.createElement(ca_ui_toolkit_1.Label, {
      label: ruleModel.hasTextHexColor ? ruleModel.getTextHexColor() : StringResources_1.default.get('conditionalFormattingNoColor'),
      style: {
        fontSize: '14px',
        paddingRight: '5px'
      }
    }), react_1.default.createElement(ColorPickerComponent_1.default, {
      onColorSelected: this._onColorSelected.bind(this, ruleIndex,
      /* isTextColor */
      true),
      className: ca_ui_toolkit_1.classnames('vis-cf-rule-picker', {
        'vis-cf-not-selected': !ruleModel.hasTextHexColor
      }),
      orientation: 'bottom',
      selectedColor: {
        fill: ruleModel.getTextHexColor()
      },
      uiContext: uiContext,
      colorPickerModel: colorPickerModel
    }))), !uiContext.isKpiVis() && react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      direction: 'row',
      className: ca_ui_toolkit_1.classnames('vis-cf-style-item-container'),
      maxWidth: 'unset'
    }, react_1.default.createElement(ca_ui_toolkit_1.Label, {
      label: StringResources_1.default.get('conditionalFormattingFillColor'),
      style: {
        fontSize: '14px'
      }
    }), react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      direction: 'row',
      className: ca_ui_toolkit_1.classnames('vis-cf-rule-picker-container', 'rule-color-picker-container')
    }, react_1.default.createElement(ca_ui_toolkit_1.Label, {
      label: fillLabel,
      style: {
        fontSize: '14px',
        paddingRight: '5px'
      }
    }), react_1.default.createElement(ColorPickerComponent_1.default, {
      onColorSelected: this._onColorSelected.bind(this, ruleIndex,
      /* isTextColor */
      false),
      className: ca_ui_toolkit_1.classnames('vis-cf-rule-picker', {
        'vis-cf-not-selected': !ruleModel.hasFillColor
      }),
      orientation: 'bottom',
      selectedColor: {
        color: ruleModel.getTextHexColor(),
        fill: ruleModel.getFillHexColor()
      },
      uiContext: uiContext,
      hasDefaultFillColor: true,
      colorPickerModel: colorPickerModel
    }))), react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      direction: 'row',
      className: ca_ui_toolkit_1.classnames('vis-cf-style-item-container'),
      maxWidth: 'unset'
    }, react_1.default.createElement(ca_ui_toolkit_1.Label, {
      label: StringResources_1.default.get('conditionalFormattingShape'),
      style: {
        fontSize: '14px',
        alignSelf: 'center'
      }
    }), react_1.default.createElement(ca_ui_toolkit_1.FlexLayout, {
      direction: 'row',
      className: ca_ui_toolkit_1.classnames('vis-cf-rule-picker-container', 'vis-cf-rule-shape-picker-container')
    }, react_1.default.createElement(ca_ui_toolkit_1.Label, {
      label: ruleModel.hasShape ? IconsMap_1.default.getShapeDefinition(uiContext.getIcons(), ruleModel.getShape()).label : StringResources_1.default.get('conditionalFormattingIconNone'),
      style: {
        fontSize: '14px',
        paddingRight: '5px'
      }
    }), react_1.default.createElement(IconPickerComponent_1.default, {
      onIconSelected: function onIconSelected(shape) {
        return ruleModel.setShape(ruleIndex, shape.shapeId);
      },
      className: ca_ui_toolkit_1.classnames('vis-cf-rule-picker', 'vis-cf-icon-picker', {
        'vis-cf-not-selected': !ruleModel.hasShape
      }),
      orientation: 'bottom',
      icons: iconOptions,
      selectedIcon: ruleModel.hasShape ? IconsMap_1.default.getShapeDefinition(uiContext.getIcons(), ruleModel.getShape()) : ''
    }))), react_1.default.createElement(ca_ui_toolkit_1.FlexItem, {
      alignSelf: 'flex-end',
      className: 'vis-cf-delete-rule-container'
    }, react_1.default.createElement(ca_ui_toolkit_1.Button, {
      className: ca_ui_toolkit_1.classnames('vis-cf-delete-rule-button'),
      iconRight: uiContext.getIcons().getIcon('TrashIcon'),
      size: 'small',
      button: false,
      tabIndex: 0,
      focusable: true,
      label: StringResources_1.default.get('conditionalFormattingDeleteRule'),
      onClick: function onClick() {
        return removeRule(ruleIndex);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.keyCode === KeyCodes_1.KeyCodes.ENTER || e.keyCode === KeyCodes_1.KeyCodes.SPACE) {
          removeRule(ruleIndex); // Prevent browser's default action: space does a PageDown

          e.preventDefault();
        }
      }
    }))));
  };

  RuleComponent.prototype.expandExpandableTile = function () {
    var ruleModel = this.props.ruleModel;
    var current = this.nodeRef.current;
    var expand = ruleModel.getExpand();

    if (expand && current) {
      // HACK: since react-collapse require the element node to be mounted into the DOM and sized corrrectly, expand won't work
      // call settimeout call here twice to mimic user interaction to expand/collapse the ExxpandableTile
      setTimeout(function () {
        current.setState({
          expanded: !current.state.expanded,
          showFocusClass: false
        });
        setTimeout(function () {
          current.setState({
            expanded: !current.state.expanded,
            showFocusClass: false
          });
        }, 0);
      }, 0);
    }
  };

  RuleComponent.prototype.collapseExpandableTile = function () {
    var current = this.nodeRef.current;

    if (current && current.state.expanded) {
      current.setState({
        expanded: !current.state.expanded,
        showFocusClass: false
      });
    }
  };

  RuleComponent.prototype.updateExpansionStateWhenPropertiesPanelMounted = function () {
    var ruleModel = this.props.ruleModel;
    var current = this.nodeRef.current;
    var expand = ruleModel.getExpand();

    if (expand && current && !current.state.expanded) {
      current.setState({
        expanded: !current.state.expanded,
        showFocusClass: false
      });
    }
  };

  RuleComponent.prototype._onColorSelected = function (ruleIndex, isTextColor, hexColor) {
    var _this = this;

    return this._loadColors().then(function (_a) {
      var colorPaletteList = _a[0];
      var _b = _this.props,
          ruleModel = _b.ruleModel,
          uiContext = _b.uiContext;
      var colorId = ColorUtil_1.default.getOrCreateColorIdFromHexColor(uiContext.getColors(), colorPaletteList, hexColor);

      if (isTextColor) {
        _this._setColors(ruleModel, isTextColor, hexColor);

        ruleModel.setTextColor(ruleIndex, colorId);
      } else {
        _this._setColors(ruleModel, isTextColor, hexColor);

        ruleModel.setFillColor(ruleIndex, colorId);
      }
    });
  };

  RuleComponent.prototype._setColors = function (ruleModel, isTextColor, hexColor) {
    if (isTextColor) {
      ruleModel.setTextHexColor(hexColor.pattern ? hexColor.fill : hexColor);
    } else {
      ruleModel.setFillHexColor(hexColor.pattern ? hexColor.color : hexColor);
      ruleModel.setFillPattern(hexColor.pattern);
    }
  };

  RuleComponent.prototype._loadColors = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a, uiContext, paletteId;

      return __generator(this, function (_b) {
        _a = this.props, uiContext = _a.uiContext, paletteId = _a.paletteId;
        return [2
        /*return*/
        , uiContext.getColorPalette(paletteId).then(function (colorPaletteList) {
          return [colorPaletteList];
        })];
      });
    });
  };

  RuleComponent.prototype._updateColors = function () {
    var _this = this;

    return this._loadColors().then(function (_a) {
      var colorPaletteList = _a[0];
      var _b = _this.props,
          ruleModel = _b.ruleModel,
          uiContext = _b.uiContext;
      var pattern;
      var textHexColor;
      var fillHexColor;
      var hexColor = ColorUtil_1.default.getHexColorOrFillFromColorId(uiContext.getColors(), colorPaletteList, ruleModel.getTextColor());

      if (hexColor) {
        textHexColor = hexColor;

        if (hexColor.pattern) {
          pattern = hexColor.pattern;
          textHexColor = hexColor.color;
        }
      }

      if (!uiContext.isKpiVis()) {
        hexColor = ColorUtil_1.default.getHexColorOrFillFromColorId(uiContext.getColors(), colorPaletteList, ruleModel.getFillColor());

        if (hexColor) {
          if (hexColor.pattern) {
            pattern = hexColor.pattern;
            fillHexColor = hexColor.fill;
          } else {
            fillHexColor = hexColor;
          }
        }
      }

      ruleModel.setTextHexColor(textHexColor);
      ruleModel.setFillHexColor(fillHexColor);
      ruleModel.setFillPattern(pattern);
    });
  };

  RuleComponent.prototype._supportRangeCondition = function (startConditionType) {
    return RANGE_CONDITION_TYPES.includes(startConditionType);
  };

  RuleComponent.prototype._updateComponent = function () {
    var _this = this;

    return this._updateColors().then(function () {
      var ruleModel = _this.props.ruleModel;
      var current = _this.nodeRef.current;

      if (current) {
        return new Promise(function (resolve) {
          setTimeout(function () {
            current.setState({
              expanded: ruleModel.getExpand(),
              showFocusClass: false
            });
            resolve();
          }, 0);
        });
      }

      return Promise.resolve();
    });
  };

  return RuleComponent;
}(react_1.Component);

exports.default = mobx_react_1.observer(RuleComponent);
